import React from "react";

import { isEmpty } from "ramda";

import { Pagination, Table } from "components/Common/clearsense-ui/components";
import NoData from "components/Common/NoData";

const DomainsTable = ({
  domainsLength,
  setIsAssociateDomainOpen,
  userPermissions,
  domains,
  columns,
  setCheckedRows,
  checkedRows,
  filterParams,
}) => {
  const {
    debouncedSearchTerm,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
  } = filterParams;

  if (!domainsLength && isEmpty(debouncedSearchTerm)) {
    return (
      <NoData
        entity="domain"
        actionLabel="Associate Domains"
        onAction={() => setIsAssociateDomainOpen(true)}
        currentPermissions={userPermissions}
        acceptablePermissions="associate"
      />
    );
  }

  return (
    <div className="mt-8">
      <Table
        rowData={domains || []}
        columnData={columns.selected}
        rowKey={record => record.id}
        onRowSelect={(_, selectedRows) => setCheckedRows(selectedRows)}
        rowSelection={{
          onSelect: (_, __, selectedRows) => setCheckedRows(selectedRows),
          selectedRowKeys: checkedRows.map(row => row.id),
          onSelectAll: () =>
            checkedRows.length === domains.length
              ? setCheckedRows([])
              : setCheckedRows(domains),
        }}
      />
      {columns.selected.length > 0 && (
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          showResultsPerPage
          totalRecordsCount={domainsLength}
        />
      )}
    </div>
  );
};

export default DomainsTable;
